(function () {
    'use strict';

    angular
        .module('app.core')
        .decorator('$locale', $localeDecorator);

    $localeDecorator.$inject = ['$delegate'];
    function $localeDecorator($delegate) {
        var dateTimeFormats = $delegate.DATETIME_FORMATS,
            shortDate,
            generalDate,
            rYear = /y+/g,
            rDay = /(-|\/)d+/g;

        setShortDate(dateTimeFormats.shortDate);
        Object.defineProperty(dateTimeFormats, 'shortDate', { get: getShortDate, set: setShortDate });
        Object.defineProperty(dateTimeFormats, 'generalDate', { get: getGeneralDate });
        return $delegate;

        function getShortDate() {
            return shortDate;
        }
        function setShortDate(value) {
            // Correct the short date.  Should not be a 2 digits year.  Set the generalDate also.
            if (isNorthAmericanEnglishOrFrench()) {
                shortDate = value && value.replace(rYear, 'yyyy') || value;
                generalDate = shortDate && shortDate.replace(rDay, '') || shortDate;
            }
            else {
                shortDate = generalDate = value;
            }
        }

        function getGeneralDate() {
            return generalDate;
        }
        function isNorthAmericanEnglishOrFrench() {
            return $delegate.id === 'en-us' || $delegate.id === 'en-ca' || $delegate.id === 'fr-ca'
        }
    }
})();